import z from 'zod';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';

const baseSimpleDisplayCfgSchema = z.object({
    kind: z.string(),
});

const simpleDisplayCfgSchema = baseSimpleDisplayCfgSchema.extend({
    kind: z.literal('simple'),
    style: z.enum([ 'default', 'lessDetail', 'auto' ]),
    btnCfg: z.object({
        label: z.string(),
        color: z.string(),
    }),
});

const advancedDisplayCfgSchema = baseSimpleDisplayCfgSchema.extend({
    kind: z.literal('advanced'),
    // cell ids in this list will not show up in the tree view and will not be available to be linked to a screen
    excludedCellIds: z.array(z.string()).default([]),
});

const workInstructionDisplayCfgSchema = z.discriminatedUnion('kind', [
    simpleDisplayCfgSchema,
    advancedDisplayCfgSchema,
]);

export const workInstructionCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('workInstruction'),
    attrs: cellCfgAttrsBaseSchema.extend({
        displayCfg: workInstructionDisplayCfgSchema,
        workInstructionName: z.string().default(''),
        workInstructionVersionId: z.string().nullable().default(null),
    }),
});
